import z from 'zod';
export const E164PhoneSchema = z.string().regex(/^\+[1-9]\d{10,15}$/, "Phone must follow valid E-164 format,+[country code][subscriber number with area code],for example: +19876543210");